// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

const categoriesServiceUrl = "/api/vmi/category/featuredCategories";

export interface FeaturedCategoriesApiParameter extends ApiParameter {
    numberOfCategoriesToReturn: number;
    categoriesList: string[];
}
export type FeaturedCategoryModel = {
    id: string;
    name: string;
    urlSegment: string;
    shortDescription: string;
    largeImagePath: string;
    imageAltText: string;
    properties: {
        catShortDescription?: string;
        [key: string]: string | undefined;
    };
    context: string | null;
};

export async function getCategoriesData(parameter: FeaturedCategoriesApiParameter): Promise<FeaturedCategoryModel[]> {
    const result = await post<FeaturedCategoriesApiParameter, FeaturedCategoryModel[]>(categoriesServiceUrl, parameter);
    return Array.isArray(result) ? result : [];
}
